"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
require("isomorphic-fetch");
const utils_1 = require("./utils");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
async function fetchOutputKeysInner(path) {
  try {
    let response = await fetch(path);
    let outputKeys = await response.json();
    return outputKeys;
  } catch (e) {
    console.error(e);
    return [];
  }
}
const fetchOutputKeysForCloud = async (
  dataResolver,
  cloudType,
  resourceType,
  service,
  method
) => {
  let outputKeys = [];
  try {
    let outputKey = `${cloudType}/${resourceType}/${service}/${method}/outputKeys.json`;
    outputKeys = await utils_1.getSgcData(dataResolver, outputKey);
  } catch (e) {
    console.error("Error in getting output keys", e);
  }
  return outputKeys;
};
async function getResourceType(dataResolver, cloudType, service, method) {
  let resources = await utils_1.getSgcData(
    dataResolver,
    `${cloudProvider_1.default.AWS}/resourceTypeMap.json`
  );
  return resources && resources[`${service}:${method}`];
}
async function fetchOutputKeys(dataResolver, service, method) {
  if (!service || !method) return [];
  let resourceType = await getResourceType(
    dataResolver,
    cloudProvider_1.default.AWS,
    service,
    method
  );
  if (!resourceType) return [];
  return fetchOutputKeysForCloud(
    dataResolver,
    cloudProvider_1.default.AWS,
    resourceType,
    service,
    method
  );
}
exports.fetchOutputKeys = fetchOutputKeys;
async function fetchAzureOutputKeys(dataResolver, module, service, method) {
  if (!service || !method) return [];
  return fetchOutputKeysForCloud(
    dataResolver,
    cloudProvider_1.default.AZURE,
    service,
    module,
    method
  );
}
exports.fetchAzureOutputKeys = fetchAzureOutputKeys;
async function fetchK8OutputKeys(dataResolver, service, method) {
  if (!service || !method) return [];
  let resourceType = await getResourceType(
    dataResolver,
    "KUBERNETES",
    service,
    method
  );
  if (!resourceType) return [];
  return fetchOutputKeysForCloud(
    dataResolver,
    cloudProvider_1.default.AZURE,
    resourceType,
    service,
    method
  );
}
exports.fetchK8OutputKeys = fetchK8OutputKeys;
async function fetchTerraformOutputKeys(service, method) {
  if (!service || !method) return [];
  let path = `https://tc-terraform-sdk.s3.amazonaws.com/sgc/output-keys/${service}/${method}.json`;
  return fetchOutputKeysInner(path);
}
exports.fetchTerraformOutputKeys = fetchTerraformOutputKeys;
async function fetchGCPOutputKeys(dataResolver, module, service, method) {
  if (!service || !method) return [];
  return fetchOutputKeysForCloud(
    dataResolver,
    cloudProvider_1.default.GCP,
    // resourceType
    service,
    // service
    module,
    method
  );
}
exports.fetchGCPOutputKeys = fetchGCPOutputKeys;
//# sourceMappingURL=fetchOutputKeys.js.map
